import { gql } from "@apollo/client";

import { propertyValueFragment } from "src/graphql/anti-fraud/fragments/PropertyValueFragment";

export const blacklistableIdentifierFragment = gql`
  fragment BlacklistableIdentifierFragment on BlacklistableCaseIdentifier {
    element {
      id
      name
      typeCode
    }
    belongsToCurrentCase
    identifier {
      id
      schemaIdentifier {
        code
      }
      value
      identifierType {
        name
        code
      }
    }
    linkedCases {
      id
      properties {
        ...PropertyValueFragment
      }
    }
    blacklist {
      name
      code
    }
  }

  ${propertyValueFragment}
`;
